import React from 'react';
import * as _ from 'lodash';
import { USER_ROLES } from '../utilities/constants';
import { FormItem } from './FormBase';
import { UserTypeSwitchForm } from './UserTypeSwitchForm';
import {
  InputForm,
  Validation,
  FileInputForm,
  FormDropDownSingleSelect,
  FormDropDown,
} from './CommonFormComponents';
import { createLocalEventManager } from '../utilities/EventManager';
import { isTargetRoleId } from '../utilities/roleUtility';
import RequireIcon from '../components/RequireIcon';
import { messageUtility } from '../utilities/messageUtility';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';

const ValidationMessage = {
  name_sei: '必須です。64文字以下で入力してください',
  name_mei: '必須です。64文字以下で入力してください',
  kana_sei: '必須です。ひらがなで128文字以下で入力してください',
  kana_mei: '必須です。ひらがなで128文字以下で入力してください',
  company_id: '必須です。元請が選択されていません',
  password: '必須です。8文字以上32文字以下にしてください',
  password_confirmation: 'パスワードと同じ値にしてください',
};

const NewValidation = props => (
  <Validation
    validate={
      props.validate
        ? ValidationMessage[props.id]
          ? ValidationMessage[props.id]
          : props.validate
        : null
    }
  />
);

/**
 * @description ユーザー種別で使うラジオボタン
 */
const UserTypeItem = ({
  match_id,
  label,
  name,
  type,
  value,
  params,
  disabled,
  onUpdate,
  onValidationCheck,
  className,
  maxLength,
  placeholder,
  contentEditable,
  style,
  accept,
}) => (
  <UserTypeSwitchForm match_id={match_id}>
    <div className='form-list-radio__item'>
      <label className={`radio ${disabled ? 'disabled' : ''}`}>
        <InputForm
          {...{
            name,
            type,
            value,
            params,
            disabled,
            onUpdate,
            onValidationCheck,
            className,
            maxLength,
            placeholder,
            contentEditable,
            style,
            accept,
          }}
          value={value === params}
          type='radio'
          name='UserType'
          params={params}
        />
        <i className='i-circle i-3x' aria-hidden='true' />
        {label}
      </label>
    </div>
  </UserTypeSwitchForm>
);

/**
 * @description 画像ファイルアイコン & アップロード
 */
export const IconForm = props => (
  <FormItem {...props}>
    {({ value, validate, disabled, onUpdate }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>画像ファイルアイコン</span>
          </div>
          <FileInputForm
            {...{
              value,
              validate,
              disabled,
              onUpdate,
            }}
            validate={
              props.validate
                ? ValidationMessage[props.id]
                  ? ValidationMessage[props.id]
                  : props.validate
                : null
            }
          />
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description ユーザー種別
 */
export const UserType = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              ユーザー種別
              <RequireIcon isShow={!props.disabled} />
            </span>
          </div>
          <div className='form-list__element'>
            <div className='form-list-radio'>
              <UserTypeItem
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                label='本社管理者'
                match_id={USER_ROLES.prime.id}
                params={USER_ROLES.prime.id}
              />
              <UserTypeItem
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                label='支店管理者'
                match_id={[USER_ROLES.prime.id, USER_ROLES.branch.id]}
                params={USER_ROLES.branch.id}
              />
              <UserTypeItem
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                label='現場監督'
                match_id={[
                  USER_ROLES.prime.id,
                  USER_ROLES.branch.id,
                  USER_ROLES.manager.id,
                ]}
                params={USER_ROLES.manager.id}
              />
            </div>
            <div style={{ width: '100%' }}>
              <NewValidation id={props.id} validate={props.validate} />
            </div>
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description ユーザー種別 (協力会社用)
 */
export const UserTypePartner = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              ユーザー種別
              <RequireIcon isShow />
            </span>
          </div>
          <div className='form-list-radio'>
            <UserTypeItem
              {...{
                value,
                name,
                disabled,
                onUpdate,
                onValidationCheck,
              }}
              label='協力会社管理者'
              match_id={[
                USER_ROLES.prime.id,
                USER_ROLES.partner.id,
                USER_ROLES.operator.id,
                USER_ROLES.foreman.id,
              ]}
              params={USER_ROLES.partner.id}
            />
            <UserTypeItem
              {...{
                value,
                name,
                disabled,
                onUpdate,
                onValidationCheck,
              }}
              label='職長'
              match_id={[
                USER_ROLES.prime.id,
                USER_ROLES.partner.id,
                USER_ROLES.operator.id,
                USER_ROLES.foreman.id,
              ]}
              params={USER_ROLES.foreman.id}
            />
          </div>
          <NewValidation id={props.id} validate={props.validate} />
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description 職長パスワードリセット通知先
 */
export const PasswardChange = data => {
  return (
    <li className='form-list__item'>
      <div className='form-list__label'>
        <span className='label'>職長パスワードリセット通知先</span>
      </div>
      {data.flg ? <div className='form-list__element'>通知先</div> : null}
    </li>
  );
};

/**
 * @description 姓
 */
export const LastName = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              姓<RequireIcon isShow={!props.disabled} />
            </span>
          </div>
          <div className='form-list__element'>
            <InputForm
              {...{ name, value, disabled, onUpdate, onValidationCheck }}
              placeholder='（例）山田'
              maxlength='64'
            />
            <NewValidation id={props.id} validate={props.validate} />
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description 名
 */
export const FirstName = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              名<RequireIcon isShow={!props.disabled} />
            </span>
          </div>
          <div className='form-list__element'>
            <InputForm
              {...{
                value,
                name,
                disabled,
                onUpdate,
                onValidationCheck,
              }}
              placeholder='（例）太郎'
              class='--col-xl-5 --col-lg-5 --col-md-5 --col-xs-5 sys-key-user_name_sei sys-name'
              maxlength='64'
            />
            <NewValidation id={props.id} validate={props.validate} />
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description せい
 */
export const LastNameKana = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              せい
              <RequireIcon isShow={!props.disabled} />
            </span>
          </div>
          <div className='form-list__element'>
            <InputForm
              {...{
                value,
                name,
                disabled,
                onUpdate,
                onValidationCheck,
              }}
              placeholder='（例）やまだ'
              class='--col-xl-5 --col-lg-5 --col-md-5 --col-xs-5 sys-key-user_name_sei sys-name'
              maxlength='128'
            />
            <NewValidation id={props.id} validate={props.validate} />
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description めい
 */
export const FirstNameKana = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              めい
              <RequireIcon isShow={!props.disabled} />
            </span>
          </div>
          <div className='form-list__element'>
            <InputForm
              {...{
                value,
                name,
                disabled,
                onUpdate,
                onValidationCheck,
              }}
              placeholder='（例）たろう'
              class='--col-xl-5 --col-lg-5 --col-md-5 --col-xs-5 sys-key-user_name_sei sys-name'
              maxlength='128'
            />
            <NewValidation id={props.id} validate={props.validate} />
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description 電話番号
 */
export const Tel = props => (
  <FormItem
    {...props}
    defaultValue={props.defaultValue === '--' ? '' : props.defaultValue}
  >
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      value = value ? value : '--';
      const [num1, num2, num3] = value.split('-');

      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>電話番号</span>
          </div>
          <div className='form-list__element'>
            <label htmlFor='tel' className='input-tel'>
              <InputForm
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                value={num1}
                placeholder={props.disabled === true ? '' : '03'}
                maxlength='5'
                onUpdate={(value, params, target) => {
                  if (!value.match(/-/)) {
                    onUpdate(value, params, target);
                  }
                }}
                params={val => {
                  const tel = value.replace(/^[^-]*-/, `${val}-`);
                  return tel === '--' ? '' : tel;
                }}
              />
              -
              <InputForm
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                value={num2}
                placeholder={props.disabled === true ? '' : '1234'}
                maxlength='4'
                onUpdate={(value, params, target) => {
                  if (!value.match(/-/)) {
                    onUpdate(value, params, target);
                  }
                }}
                params={val => {
                  const tel = value.replace(/-[^-]*-/, `-${val}-`);
                  return tel === '--' ? '' : tel;
                }}
              />
              -
              <InputForm
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                value={num3}
                placeholder={props.disabled === true ? '' : '5678'}
                maxlength='4'
                onUpdate={(value, params, target) => {
                  if (!value.match(/-/)) {
                    onUpdate(value, params, target);
                  }
                }}
                params={val => {
                  const tel = value.replace(/-[^-]*$/, `-${val}`);
                  return tel === '--' ? '' : tel;
                }}
              />
            </label>
            <NewValidation id={props.id} validate={props.validate} />
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description ユーザーID(メールアドレス)
 */
export const Email = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              ユーザーID(メールアドレス)
              <RequireIcon isShow={!props.disabled} />
            </span>
          </div>
          <div className='form-list__element'>
            <InputForm
              {...{
                value,
                name,
                disabled,
                onUpdate,
                onValidationCheck,
              }}
              placeholder='メールアドレスを入力'
              className='--col-xl-5 --col-lg-5 --col-md-5 --col-xs-5 form-width'
              maxlength='255'
            />
            <NewValidation id={props.id} validate={props.validate} />
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description 必須ではない Email (職長、作業員の時に使用)
 */
export const SubEmail = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              メールアドレス
              {!disabled && (
                <span className='form_label__icon form_label__icon--recommended'>
                  推奨
                </span>
              )}
            </span>
          </div>
          <div className='form-list__element'>
            <InputForm
              {...{
                value,
                name,
                disabled,
                onUpdate,
                onValidationCheck,
              }}
              placeholder='メールアドレスを入力'
              className='--col-xl-5 --col-lg-5 --col-md-5 --col-xs-5 form-width'
              maxlength='255'
            />
            <NewValidation id={props.id} validate={props.validate} />
            {!disabled && (
              <span className='form-list__supplemental-info'>
                {messageUtility.getMessage('I-001-418')}
              </span>
            )}
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description ユーザーID (職長、作業員の時に使用)
 */
export const UserId = props => (
  <FormItem {...props}>
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              ユーザーID
              <RequireIcon isShow={!props.disabled} />
            </span>
          </div>
          <div className='form-list__element'>
            <InputForm
              {...{
                value,
                name,
                disabled,
                onUpdate,
                onValidationCheck,
              }}
              placeholder='ユーザーIDを入力'
              className='--col-xl-5 --col-lg-5 --col-md-5 --col-xs-5'
              maxlength='60'
            />
            <NewValidation id={props.id} validate={props.validate} />
            <span className='form-list__supplemental-info'>
              {messageUtility.getMessage('I-001-252')}
            </span>
          </div>
        </li>
      );
    }}
  </FormItem>
);

/**
 * @description 支店
 */
export const Shiten = props => {
  if (props.fixedFlag === true) {
    return (
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>支店</span>
        </div>
        <div className='form-element__element'>
          <div className='dropdown-single-select dropdownselect'>
            <div className='dropdown-single-select__header'>
              <div className='dropdown-select dropdown-select--fixed'>
                <span className='dropdown-select__txt'>
                  {isTargetRoleId([USER_ROLES.prime], props.userRoleCode) ? (
                    '本社'
                  ) : (
                    <React.Fragment>
                      {_.defaultTo(props.fixedCompanyBranch.name, '　')}
                    </React.Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  } else {
    return (
      <FormItem
        {...props}
        defaultValue={props.defaultValue ? props.defaultValue.id : null}
        changeValueInMount={true}
      >
        {({ onUpdate }) => {
          return (
            <li className='form-list__item'>
              <div className='form-list__label'>
                <span className='label'>
                  支店
                  <RequireIcon isShow={!props.disabled} />
                </span>
              </div>
              <div className='form-element__element'>
                <FormDropDownSingleSelect
                  className='shiten'
                  disabled={props.disabled}
                  label='支店を指定'
                  placeholder='支店名を選択'
                  apiPath='/api/private/company_branches/list'
                  entitiesKey='company_branches'
                  defaultValue={props.defaultValue}
                  callback={value => onUpdate(value.id)}
                  event={props.event}
                />
                <NewValidation id={props.id} validate={props.validate} />
              </div>
            </li>
          );
        }}
      </FormItem>
    );
  }
};

const CompanyEvent = createLocalEventManager({ CHANGE: 'change' });

/**
 * @description 「元請会社／協力会社」(ビュー専用ドロップダウン版の共通のView)
 */
const CommonCompanyDropdown = props => (
  <li className='form-list__item'>
    <div className='form-list__label'>
      <span className='label'>{messageUtility.getMessage('I-001-011')}</span>
    </div>
    <div className='form-element__element form-list__element--dropdown'>
      {/* ビュー専用 */}
      <FormDropDown
        apiPath={props.apiPath}
        // 表示に使う返却値のキー
        itemKey='display'
        entitiesKey='company'
        disabled={props.disabled}
        params={props.params}
        readOnly={props.readOnly}
      />
    </div>
  </li>
);

/**
 * company_branch内のcompany_idを取得する
 *
 * @param {*} companyBranch company_branch
 * @returns
 */
const getCompanyBranchCompanyId = companyBranch => {
  if (companyBranch) {
    return companyBranch.company_id;
  }

  return null;
};

/**
 * @description 「元請会社／協力会社」(ビュー専用ドロップダウン版)
 */
export const CompanyBaseDropdown = props => (
  <CommonCompanyDropdown
    apiPath='/api/private/company_branches/prime_list'
    params={getCompanyBranchCompanyId(props.companyBranch)}
    disabled={props.disabled}
    readOnly
  />
);

/**
 * @description 「元請会社／協力会社」(ビュー専用ドロップダウン版/指定ユーザに関連する会社を取得)
 */
export const CompanyFromUserDropdown = props => (
  <CommonCompanyDropdown
    apiPath={`/api/private/users/${props.userId}/prime_list`}
    disabled={props.disabled}
  />
);

/**
 * @description 新規利用者登録画面(協力会社)の「元請会社／協力会社」選択コンポーネント
 *
 * @param {*} props
 */
export const CompanyBase = props => (
  <FormItem {...props}>
    {({ EventMg, onUpdate }) => {
      return (
        <div className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>
              {messageUtility.getMessage('I-001-011')}
            </span>
          </div>
          <div className='form-list__element'>
            {/* DropDownのコンポーネントだがisReadOnlyでラベル表示 */}
            {/* API呼び出してリストから選択する処理は必要なのでDropDownのコンポーネントを使用 */}
            <FormDropDownSingleSelect
              isReadOnly={true}
              apiPath='/api/private/company_branches/prime_list'
              // 表示に使う返却値のキー
              itemKey='display'
              entitiesKey='company'
              params={{
                company_id: SessionStorageService.getItem(
                  'sessionPartnerCompanyIdOfPrimeCompany'
                ),
              }}
              selectedIdType='partner_company_id'
              selectedValue={SessionStorageService.getItem(
                'sessionPartnerCompanyIdOfPrimeCompany'
              )}
              callback={value => {
                // undefinedの時があるのでチェック
                if (_.isUndefined(value)) {
                  console.error('データがおかしい');
                  return;
                }

                // company_id取得のため
                if (value.company_branches) {
                  const companyBranchCompanyId =
                    value.company_branches.company_id;
                  CompanyEvent.trigger('change', value);
                  onUpdate(value, companyBranchCompanyId);

                  EventMg.trigger('input_change_value', {
                    id: 'company_branch_id',
                    value: companyBranchCompanyId,
                  });
                }
              }}
            />
          </div>
        </div>
      );
    }}
  </FormItem>
);

/**
 * @description FAX
 */
export const Fax = props => (
  <FormItem
    {...props}
    defaultValue={props.defaultValue === '--' ? '' : props.defaultValue}
  >
    {({ value, name, disabled, onUpdate, onValidationCheck }) => {
      value = value ? value : '--';
      const [num1, num2, num3] = value.split('-');

      return (
        <li className='form-list__item'>
          <div className='form-list__label'>
            <span className='label'>FAX番号</span>
          </div>
          <div className='form-list__element'>
            <label htmlFor='Fax' className='input-tel'>
              <InputForm
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                value={num1}
                placeholder={props.disabled === true ? '' : '03'}
                maxlength='5'
                onUpdate={(value, params, target) => {
                  if (!value.match(/-/)) {
                    onUpdate(value, params, target);
                  }
                }}
                params={val => {
                  const tel = value.replace(/^[^-]*-/, `${val}-`);
                  return tel === '--' ? '' : tel;
                }}
              />
              -
              <InputForm
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                value={num2}
                placeholder={props.disabled === true ? '' : '1234'}
                maxlength='4'
                onUpdate={(value, params, target) => {
                  if (!value.match(/-/)) {
                    onUpdate(value, params, target);
                  }
                }}
                params={val => {
                  const tel = value.replace(/-[^-]*-/, `-${val}-`);
                  return tel === '--' ? '' : tel;
                }}
              />
              -
              <InputForm
                {...{
                  value,
                  name,
                  disabled,
                  onUpdate,
                  onValidationCheck,
                }}
                value={num3}
                placeholder={props.disabled === true ? '' : '5678'}
                maxlength='4'
                onUpdate={(value, params, target) => {
                  if (!value.match(/-/)) {
                    onUpdate(value, params, target);
                  }
                }}
                params={val => {
                  const tel = value.replace(/-[^-]*$/, `-${val}`);
                  return tel === '--' ? '' : tel;
                }}
              />
            </label>
            <NewValidation id={props.id} validate={props.validate} />
          </div>
        </li>
      );
    }}
  </FormItem>
);



// WEBPACK FOOTER //
// ./src/components/UserFormElements.jsx